/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const facilityType = async (): Promise<any> => {
  const facilityType = useJSONStore.getState().facilityType;
  const token = useUserStore.getState().userToken;
  const setFacilityType = useJSONStore.getState().setFacilityType;

  if (facilityType.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.facilityType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setFacilityType(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default facilityType;
